<template>
  <div>
    <!-- <el-row>
      <h2>进销存汇总表</h2>
    </el-row> -->
    <!-- <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="search" :loading="loading">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="exportData">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" @click="exportAverageData">导出均价</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col>
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column v-for="item in typeList" :label="item.NAME" :key="item.CODE" :prop="item.CODE">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import util from "@/assets/common/util";

export default {
  props: {
    searchForm2: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      searchForm: this.searchForm2,
      loading: false,
      tableData: [],
      typeList: [],
      flag: 1,
    };
  },
  created() {
    // this.$set(this.searchForm, 'DAY_INTERVAL', this.$store.state.TOTALDEPOSITPURCHASE_ALL.DAY_INTERVAL);
    this.search();
  },
  methods: {
    /**
         * datetimerange
         * 处理时间   处理格式例子：2020-09-01
         * params   未经new Date处理的日期  firstTime, endTime
         * return   Array   [firstTime, endTime]
         */
    setDateTimeRange(timeArr) {
      const firstTime = timeArr[0];
      const endTime = timeArr[1];
      const first = `${new Date(firstTime).getFullYear()}-${(new Date(firstTime).getMonth() + 1) < 10 ? (`0${new Date(firstTime).getMonth() + 1}`)
        : (new Date(firstTime).getMonth() + 1)}-${(new Date(firstTime).getDate()) < 10 ? (`0${new Date(firstTime).getDate()}`) : (new Date(firstTime).getDate())}`;
      const end = `${new Date(endTime).getFullYear()}-${(new Date(endTime).getMonth() + 1) < 10 ? (`0${new Date(endTime).getMonth() + 1}`)
        : (new Date(endTime).getMonth() + 1)}-${(new Date(endTime).getDate()) < 10 ? (`0${new Date(endTime).getDate()}`) : (new Date(endTime).getDate())}`;
      const timeContainer = [];
      timeContainer.push(first);
      timeContainer.push(end);
      return timeContainer;
    },
    search() {
      this.loading = true;
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 58,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      if (!this.searchForm.DAY_INTERVAL) {
        const arr = [new Date(new Date().setDate(new Date().getDate() - 30)), new Date()];
        const finalTime = this.setDateTimeRange(arr);
        this.$store.dispatch('TOTALDEPOSITPURCHASE_ALL', { DAY_INTERVAL: finalTime });
        params.START_DAY = finalTime[0];
        params.END_DAY = finalTime[1];
      } else {
        this.$store.dispatch('TOTALDEPOSITPURCHASE_ALL', { DAY_INTERVAL: this.searchForm.DAY_INTERVAL });
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.TAX_SIGN) {
        params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
      }
      if (this.searchForm.SUB_WAREHOUSE) {
        params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
      }
      http.post(params).then((res) => {
        this.tableData = res[0].DATA;
        this.typeList = res[0].TITLE_DATA;
        this.loading = false;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
        this.loading = false;
      });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 59,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SUB_WAREHOUSE) {
        params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
      }
      if (this.searchForm.TAX_SIGN) {
        params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
      }
      if (!this.searchForm.DAY_INTERVAL) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      http.post(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    exportAverageData() {
      const params = {
        SERVICE_ID: '10031',
        OTYPE: 62,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      if (this.searchForm.SUB_WAREHOUSE) {
        params.SUB_GYS_ID = Number(this.searchForm.SUB_WAREHOUSE);
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.TAX_SIGN) {
        params.TAX_SIGN = Number(this.searchForm.TAX_SIGN);
      }
      if (!this.searchForm.DAY_INTERVAL) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      http.post(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/totalDepositPurchase.vue